export default {
    common: {
        title: 'Contenuto IA',
        socialPlanner: 'Pianificatore sociale.',
        blog: 'Blog.',
        funnel: 'imbuto',
        website: 'Sito web.',
        email: 'Email.',
        words: 'Parole',
        variations: 'Varianti',
    },
};
